import { MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { updateUsersAndTeamsAdmin } from '../../../apiclients/streamsapi_bridge';

function DeleteUserandTeamAdmin(props) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false)

    async function deleteUser(e) {
        e.preventDefault();
        console.log(props.agentid);
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setIsloading(true);
        let update = {
            reqid: 88,
            siteid: siteid,
            remove_users: [props.agentid],
            teamid: props.teamInfo.team_id,
        }


        console.log("reques for delete user in DeleteUserandTeamAdmin   :::: " + JSON.stringify(update));
        let deleteFilter = await updateUsersAndTeamsAdmin(update);
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
        let deleteMsg = await deleteFilter.json();
        console.log("Response... ");
        console.log(JSON.stringify(deleteMsg));
        // debugger;
        if (deleteMsg.status == "success") {
            props.setSuccessMessage(deleteMsg.message);
            navigate("/selectedteamsettings", {
                state: { tab: "tab2", teamInfo: props.teamInfo },
            });
            window.location.reload();
        } else {
            localStorage.setItem("f_message", deleteMsg.message.errors[0].message);
            navigate("/selectedteamsettings", {
                state: { tab: "tab2", teamInfo: props.teamInfo },
            });
            window.location.reload();
        }
    }

    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            <div>
                <span className="phrecording">{t("deleteuserandteamadmin")}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => deleteUser(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
        </>
    )
}

export default DeleteUserandTeamAdmin
